/* tslint:disable */
/* eslint-disable */
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull kraken-web-ts'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 62
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/implementation/kraken-web-ts)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: '2cf0a9667eb806e96e2ed57b99dc3fb4',
  development: '46195d0a54e086957165730802316c5b'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '62',
    branch: 'main',
    source: 'kraken-web-ts',
    versionId: 'ae58b4fa-1836-4f39-93e5-9d9d95f8c50f'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * uuid assigned to client
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  client_id?: string;
  /**
   * The number of clients associated with the customer profile
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  clients_count?: number;
  /**
   * uuid of the corperation attached to a customer_profile
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  corp_id?: string;
  /**
   * Whether a user has received a CMA on their home or has tuned their value.
   */
  custom_valuations?: boolean;
  /**
   * uuid of attached customer in customer_properties
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  customer_id?: string;
  /**
   * email address on user JWT
   */
  email_address: string;
  /**
   * The domain portion (following @) of the email address associated with the users account
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [^.]+\..+ |
   */
  email_domain?: string;
  /**
   * optional portion of email between + and @
   *
   * | Rule | Value |
   * |---|---|
   * | Max Length | 256 |
   */
  email_tag?: string;
  environment: string;
  /**
   * Utility property to force disable flags and experiments for co-borrowers if a borrower on the same home is not activated. Primarily used for sticky bucketing.
   */
  force_disable?: boolean;
  /**
   * Utility property to force enable flags and experiments for co-borrowers if a borrower on the same home is activated. Primarily used for sticky bucketing.
   */
  force_enable?: boolean;
  /**
   * **Wheather or not the client is considered a buyer client type**
   */
  is_buyer?: boolean;
  /**
   * **Wheather or not the client is considered a guest client type**
   */
  is_guest?: boolean;
  /**
   * **Wheather or not the client is considered a homeowner client type**
   */
  is_homeowner?: boolean;
  /**
   * Wheather or not the user is considered a insurance agent user type
   */
  is_insurance_agent?: boolean;
  /**
   * Wheather or not the user is considered a loan officer user type
   */
  is_loan_officer?: boolean;
  /**
   * Wheather or not the user is considered a real estate agent user type
   */
  is_real_estate_agent?: boolean;
  /**
   * type of account via JWT auth
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | client, customer, homebotter, unauthed |
   */
  user_type: "client" | "customer" | "homebotter" | "unauthed";
  /**
   * Zip code of a user's property
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | \d{5} |
   */
  zipcode?: string;
}

export interface AirbnbExploredProperties {
  /**
   * What did the client interact with in their Airbnb module
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | monthly_revenue, nightly_rate, number_of_nights, basic_or_fancy, seldom_or_often |
   */
  airbnb_clicked: "monthly_revenue" | "nightly_rate" | "number_of_nights" | "basic_or_fancy" | "seldom_or_often";
}

export interface AvmAlertViewedProperties {
  /**
   * What type of AVM alert is a client exposed to
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm_alert_variance, avm_alert_low_confidence, avm_alert_non_disclosure, avm_alert_in_demand |
   */
  avm_alert_type:
    | "avm_alert_variance"
    | "avm_alert_low_confidence"
    | "avm_alert_non_disclosure"
    | "avm_alert_in_demand";
}

export interface AvmFeedbackProperties {
  /**
   * Describes how the client engages to their AVM alert in Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm_thumbs_up, avm_thumbs_down, avm_learn_more, avm_dismissed, avm_tuned |
   */
  avm_alert_response: "avm_thumbs_up" | "avm_thumbs_down" | "avm_learn_more" | "avm_dismissed" | "avm_tuned";
}

export interface BudgetSavedProperties {
  /**
   * What did the client engage with in the Your Profile tab?
   *
   * | Rule | Value |
   * |---|---|
   * | Min Items | 0 |
   * | Max Items | 5 |
   * | Unique Items | true |
   * | Item Type | string |
   *
   * @minItems 0
   * @maxItems 5
   */
  budget_input?:
    | []
    | [string]
    | [string, string]
    | [string, string, string]
    | [string, string, string, string]
    | [string, string, string, string, string];
}

export interface BuyerNavigationLinkClickedProperties {
  /**
   * Where did the client nav to from the "find a home" dropdown
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | search_homes, favorite_listings, saved_searches, explore_markets, buying_report |
   */
  buyer_navigation_link: "search_homes" | "favorite_listings" | "saved_searches" | "explore_markets" | "buying_report";
}

export interface CashoutOptionExploredProperties {
  /**
   * Describes the cashout option the client explored
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | emergency_fund, home_improvements, add_space, student_loans, credit_card_debt, solar_panels, european_vacation, new_investments |
   */
  cash_out_type:
    | "emergency_fund"
    | "home_improvements"
    | "add_space"
    | "student_loans"
    | "credit_card_debt"
    | "solar_panels"
    | "european_vacation"
    | "new_investments";
}

export interface ClientCustomizedProperties {
  /**
   * Ways clients can customize their Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | confirmed_loan, updated_loan, added_loan, updated_loan_balance, updated_budget, updated_price_point, updated_buying_timeline |
   */
  customization_type:
    | "confirmed_loan"
    | "updated_loan"
    | "added_loan"
    | "updated_loan_balance"
    | "updated_budget"
    | "updated_price_point"
    | "updated_buying_timeline";
}

export interface ClientRequestedInfoProperties {
  /**
   * Describes the digest owner's customer type
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | loan_officer, real_estate_agent, insurance_agent |
   */
  customer_type: "loan_officer" | "real_estate_agent" | "insurance_agent";
  /**
   * The type of request the client sent our customer
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | cma, tca, showing, prequal, instant_offer, should_i_sell, refi, market_temp |
   */
  request_type: "cma" | "tca" | "showing" | "prequal" | "instant_offer" | "should_i_sell" | "refi" | "market_temp";
}

export interface InsightsOverviewAdjustedProperties {
  /**
   * What did the client engage with on the Overview tab?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | you_might_pay, offer_slider, growth_slider, rental_nights, rental_income, useful_reply, not_useful_reply, possible_gain_or_loss |
   */
  overview_panel_clicked?:
    | "you_might_pay"
    | "offer_slider"
    | "growth_slider"
    | "rental_nights"
    | "rental_income"
    | "useful_reply"
    | "not_useful_reply"
    | "possible_gain_or_loss";
}

export interface InsightsViewedProperties {
  /**
   * Describes the buy grade the user is looking at
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | fair_buy, weak_buy, smart_buy |
   */
  buy_score: "fair_buy" | "weak_buy" | "smart_buy";
}

export interface InsuranceReviewedProperties {
  /**
   * How is a client engaging with the insurance module?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | confirm_insurance, snooze_insurance, more_info, update_policy_details, adjust_policy_date |
   */
  insurance_policy_checked:
    | "confirm_insurance"
    | "snooze_insurance"
    | "more_info"
    | "update_policy_details"
    | "adjust_policy_date";
}

export interface InsuranceRiskViewedProperties {
  /**
   * The risk of overpaying on a home insurance renenwel
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | low, medium, high |
   */
  risk_level: "low" | "medium" | "high";
}

export interface MapModifiedProperties {
  /**
   * The type of map modification the user did
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | map_panned, zoomed_out, zoomed_in |
   */
  search_map_adjustment: "map_panned" | "zoomed_out" | "zoomed_in";
}

export interface ModuleViewedProperties {
  /**
   * Describes the module content
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm, refi, purchase_power, cashout, airbnb, reverse_mortgage, pmi, net_worth, win, home_insurance, principal_interest, pay_extra_principal |
   */
  module_name:
    | "avm"
    | "refi"
    | "purchase_power"
    | "cashout"
    | "airbnb"
    | "reverse_mortgage"
    | "pmi"
    | "net_worth"
    | "win"
    | "home_insurance"
    | "principal_interest"
    | "pay_extra_principal";
  /**
   * The descending order in which the module was displayed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 1 |
   * | Max Value | 20 |
   */
  module_position?: number;
}

export interface PageViewedProperties {
  /**
   * Pattern of the URL of the page
   */
  page_location: string;
  /**
   * Actual URL of the page including IDs
   */
  page_path?: string;
  /**
   * Name of the page that describes the content
   */
  page_title?: string;
}

export interface PmiCheckedProperties {
  /**
   * How did a client with estimated PMI respond to the PMI quick check?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | yes, no, unsure |
   */
  pmi_quick_check: "yes" | "no" | "unsure";
}

export interface PmiIndicatedProperties {
  /**
   * PMI status in Homebot for a client
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | not_yet, soon, maybe_now |
   */
  pmi_status: "not_yet" | "soon" | "maybe_now";
}

export interface PmiInfoRequestedProperties {
  /**
   * When the PMI panel is expanded, does a client to learn about
   *
   * * home improvement
   *
   * * principal payment
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_improvement, principal_payment |
   */
  inspected_pmi_info?: "home_improvement" | "principal_payment";
}

export interface QuestionAskedProperties {
  /**
   * When a client DMs their LO/REA about a Homebot topic
   */
  direct_message_topic: string;
}

export interface SearchModifiedProperties {
  /**
   * Describes parameters the client filtered their search by
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | price_max, price_min, bedroom_min, bathroom_min, home_type, sqft_min, sqft_max, construction_year_min, construction_year_max |
   */
  search_filter_added:
    | "price_max"
    | "price_min"
    | "bedroom_min"
    | "bathroom_min"
    | "home_type"
    | "sqft_min"
    | "sqft_max"
    | "construction_year_min"
    | "construction_year_max";
}

export interface SearchSortProperties {
  /**
   * What order the client sorted their search results by
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | sort_price_low, sort_price_high, sort_sqft_smallest, sort_sqft_largest, sort_year_built_oldest, sort_year_built_newest |
   */
  search_sort_updated:
    | "sort_price_low"
    | "sort_price_high"
    | "sort_sqft_smallest"
    | "sort_sqft_largest"
    | "sort_year_built_oldest"
    | "sort_year_built_newest";
}

export interface ValueTunedProperties {
  /**
   * Describes how a client adjusts their AVM in Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tune_increase, tune_decrease |
   */
  tuned_value_direction: "tune_increase" | "tune_decrease";
}

export interface WinClickedProperties {
  /**
   * Client WIN CTA type
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | should_you_sell, new_home, equity_smart_search, share, reserve, refi, home_insurance, pmi |
   */
  win_type:
    | "should_you_sell"
    | "new_home"
    | "equity_smart_search"
    | "share"
    | "reserve"
    | "refi"
    | "home_insurance"
    | "pmi";
}

export class Identify implements BaseEvent {
  event_type = 'Identify';

  constructor(
    public event_properties: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AirbnbExplored implements BaseEvent {
  event_type = 'Airbnb Explored';

  constructor(
    public event_properties: AirbnbExploredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AvmAlertViewed implements BaseEvent {
  event_type = 'AVM Alert Viewed';

  constructor(
    public event_properties: AvmAlertViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AvmFeedback implements BaseEvent {
  event_type = 'AVM Feedback';

  constructor(
    public event_properties: AvmFeedbackProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AvmInfoViewed implements BaseEvent {
  event_type = 'AVM Info Viewed';
}

export class BudgetSaved implements BaseEvent {
  event_type = 'Budget Saved';

  constructor(
    public event_properties?: BudgetSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BuyerNavigationLinkClicked implements BaseEvent {
  event_type = 'Buyer Navigation Link Clicked';

  constructor(
    public event_properties: BuyerNavigationLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CashoutOptionExplored implements BaseEvent {
  event_type = 'Cashout Option Explored';

  constructor(
    public event_properties: CashoutOptionExploredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClientCustomized implements BaseEvent {
  event_type = 'Client Customized';

  constructor(
    public event_properties: ClientCustomizedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClientRequestedInfo implements BaseEvent {
  event_type = 'Client Requested Info';

  constructor(
    public event_properties: ClientRequestedInfoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExtraPrincipalAdjusted implements BaseEvent {
  event_type = 'Extra Principal Adjusted';
}

export class HomeAdded implements BaseEvent {
  event_type = 'Home Added';
}

export class HomeFavorited implements BaseEvent {
  event_type = 'Home Favorited';
}

export class InsightsOverviewAdjusted implements BaseEvent {
  event_type = 'Insights Overview Adjusted';

  constructor(
    public event_properties?: InsightsOverviewAdjustedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InsightsViewed implements BaseEvent {
  event_type = 'Insights Viewed';

  constructor(
    public event_properties: InsightsViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InsuranceReviewed implements BaseEvent {
  event_type = 'Insurance Reviewed';

  constructor(
    public event_properties: InsuranceReviewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InsuranceRiskViewed implements BaseEvent {
  event_type = 'Insurance Risk Viewed';

  constructor(
    public event_properties: InsuranceRiskViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListingCopied implements BaseEvent {
  event_type = 'Listing Copied';
}

export class ListingSharedViaWebShareApi implements BaseEvent {
  event_type = 'Listing Shared Via Web Share API';
}

export class MapModified implements BaseEvent {
  event_type = 'Map Modified';

  constructor(
    public event_properties: MapModifiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MarketTempClicked implements BaseEvent {
  event_type = 'Market Temp Clicked';
}

export class ModuleViewed implements BaseEvent {
  event_type = 'Module Viewed';

  constructor(
    public event_properties: ModuleViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NetWorthExplored implements BaseEvent {
  event_type = 'Net Worth Explored';
}

export class PageViewed implements BaseEvent {
  event_type = 'Page Viewed';

  constructor(
    public event_properties: PageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PmiChecked implements BaseEvent {
  event_type = 'PMI Checked';

  constructor(
    public event_properties: PmiCheckedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PmiIndicated implements BaseEvent {
  event_type = 'PMI Indicated';

  constructor(
    public event_properties: PmiIndicatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PmiInfoRequested implements BaseEvent {
  event_type = 'PMI Info Requested';

  constructor(
    public event_properties?: PmiInfoRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PmiRemoved implements BaseEvent {
  event_type = 'PMI Removed';
}

export class QuestionAsked implements BaseEvent {
  event_type = 'Question Asked';

  constructor(
    public event_properties: QuestionAskedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchCompleted implements BaseEvent {
  event_type = 'Search Completed';
}

export class SearchModified implements BaseEvent {
  event_type = 'Search Modified';

  constructor(
    public event_properties: SearchModifiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchSaved implements BaseEvent {
  event_type = 'Search Saved';
}

export class SearchSort implements BaseEvent {
  event_type = 'Search Sort';

  constructor(
    public event_properties: SearchSortProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ValueTuned implements BaseEvent {
  event_type = 'Value Tuned';

  constructor(
    public event_properties: ValueTunedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WinClicked implements BaseEvent {
  event_type = 'WIN Clicked';

  constructor(
    public event_properties: WinClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class YearsInHomeAdjusted implements BaseEvent {
  event_type = 'Years In Home Adjusted';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      // @ts-ignore
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Airbnb Explored
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Airbnb%20Explored)
   *
   * How did a client engage with Homebot's Airbnb module?
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. airbnb_clicked)
   * @param options Amplitude event options.
   */
  airbnbExplored(
    properties: AirbnbExploredProperties,
    options?: EventOptions,
  ) {
    return this.track(new AirbnbExplored(properties), options);
  }

  /**
   * AVM Alert Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/AVM%20Alert%20Viewed)
   *
   * Client was exposed to 1 of the 4 AVM alerts
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. avm_alert_type)
   * @param options Amplitude event options.
   */
  avmAlertViewed(
    properties: AvmAlertViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AvmAlertViewed(properties), options);
  }

  /**
   * AVM Feedback
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/AVM%20Feedback)
   *
   * Client provided feedback by engaging with an AVM alert
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. avm_alert_response)
   * @param options Amplitude event options.
   */
  avmFeedback(
    properties: AvmFeedbackProperties,
    options?: EventOptions,
  ) {
    return this.track(new AvmFeedback(properties), options);
  }

  /**
   * AVM Info Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/AVM%20Info%20Viewed)
   *
   * Client clicked "Learn about home estimates” button
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  avmInfoViewed(
    options?: EventOptions,
  ) {
    return this.track(new AvmInfoViewed(), options);
  }

  /**
   * Budget Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Budget%20Saved)
   *
   * Client added or edited their budget
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. budget_input)
   * @param options Amplitude event options.
   */
  budgetSaved(
    properties?: BudgetSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BudgetSaved(properties), options);
  }

  /**
   * Buyer Navigation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Buyer%20Navigation%20Link%20Clicked)
   *
   * Captures **the navigation link a buyer clicked on** in both the desktop and mobile buyer navigation experiences
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. buyer_navigation_link)
   * @param options Amplitude event options.
   */
  buyerNavigationLinkClicked(
    properties: BuyerNavigationLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuyerNavigationLinkClicked(properties), options);
  }

  /**
   * Cashout Option Explored
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Cashout%20Option%20Explored)
   *
   * This event's property (cash*\_*out_type) describes the cashout option the client explored
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. cash_out_type)
   * @param options Amplitude event options.
   */
  cashoutOptionExplored(
    properties: CashoutOptionExploredProperties,
    options?: EventOptions,
  ) {
    return this.track(new CashoutOptionExplored(properties), options);
  }

  /**
   * Client Customized
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Client%20Customized)
   *
   * The client updated or confirmed important fields that customized their experience
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. customization_type)
   * @param options Amplitude event options.
   */
  clientCustomized(
    properties: ClientCustomizedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClientCustomized(properties), options);
  }

  /**
   * Client Requested Info
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Client%20Requested%20Info)
   *
   * The client asked for important information that the customer needs to respond to
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. customer_type)
   * @param options Amplitude event options.
   */
  clientRequestedInfo(
    properties: ClientRequestedInfoProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClientRequestedInfo(properties), options);
  }

  /**
   * Extra Principal Adjusted
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Extra%20Principal%20Adjusted)
   *
   * Client adjusted extra monthly principal dropdown
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  extraPrincipalAdjusted(
    options?: EventOptions,
  ) {
    return this.track(new ExtraPrincipalAdjusted(), options);
  }

  /**
   * Home Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Home%20Added)
   *
   * Client self added a new home via /home/new
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  homeAdded(
    options?: EventOptions,
  ) {
    return this.track(new HomeAdded(), options);
  }

  /**
   * Home Favorited
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Home%20Favorited)
   *
   * Client favorited a listing
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  homeFavorited(
    options?: EventOptions,
  ) {
    return this.track(new HomeFavorited(), options);
  }

  /**
   * Insights Overview Adjusted
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Insights%20Overview%20Adjusted)
   *
   * How did a client engage with the Overview information in the finanical insights panel on a home listing?
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. overview_panel_clicked)
   * @param options Amplitude event options.
   */
  insightsOverviewAdjusted(
    properties?: InsightsOverviewAdjustedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsightsOverviewAdjusted(properties), options);
  }

  /**
   * Insights Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Insights%20Viewed)
   *
   * Client clicks on button to view personal financial insights on a listing in Homebot Home Search
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. buy_score)
   * @param options Amplitude event options.
   */
  insightsViewed(
    properties: InsightsViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsightsViewed(properties), options);
  }

  /**
   * Insurance Reviewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Insurance%20Reviewed)
   *
   * When clients click the "More information on this" button on their insurance module.
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. insurance_policy_checked)
   * @param options Amplitude event options.
   */
  insuranceReviewed(
    properties: InsuranceReviewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsuranceReviewed(properties), options);
  }

  /**
   * Insurance Risk Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Insurance%20Risk%20Viewed)
   *
   * When a client views the home insurance module, we capture the risk level of overpaying on a homeinsurance renewel.
   *
   * Owner: Bret Doucette
   *
   * @param properties The event's properties (e.g. risk_level)
   * @param options Amplitude event options.
   */
  insuranceRiskViewed(
    properties: InsuranceRiskViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsuranceRiskViewed(properties), options);
  }

  /**
   * Listing Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Listing%20Copied)
   *
   * Track when a user clicks the ‘copy link’ icon on listing gallery cards.
   *
   *  Icon shown to clients depends on using a browser capable of native sharing. This event will track browsers that **do not** support webshare.
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  listingCopied(
    options?: EventOptions,
  ) {
    return this.track(new ListingCopied(), options);
  }

  /**
   * Listing Shared Via Web Share API
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Listing%20Shared%20Via%20Web%20Share%20API)
   *
   * Track when a user clicks the ‘share’ icon on listing gallery cards.  Icon shown to clients depends on using a browser capable of native sharing. This event will track browsers that **do** support webshare.
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  listingSharedViaWebShareApi(
    options?: EventOptions,
  ) {
    return this.track(new ListingSharedViaWebShareApi(), options);
  }

  /**
   * Map Modified
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Map%20Modified)
   *
   * Client using Home Search adjusted the map to view listings
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. search_map_adjustment)
   * @param options Amplitude event options.
   */
  mapModified(
    properties: MapModifiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MapModified(properties), options);
  }

  /**
   * Market Temp Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Market%20Temp%20Clicked)
   *
   * Client clicked CTA to access the Your Market panel
   *
   * Owner: Martha Bawn
   *
   * @param options Amplitude event options.
   */
  marketTempClicked(
    options?: EventOptions,
  ) {
    return this.track(new MarketTempClicked(), options);
  }

  /**
   * Module Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Module%20Viewed)
   *
   * Client viewed a specific module
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. module_name)
   * @param options Amplitude event options.
   */
  moduleViewed(
    properties: ModuleViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ModuleViewed(properties), options);
  }

  /**
   * Net Worth Explored
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Net%20Worth%20Explored)
   *
   * User clicked 'how is this calculated' below their net worth amount
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  netWorthExplored(
    options?: EventOptions,
  ) {
    return this.track(new NetWorthExplored(), options);
  }

  /**
   * Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Page%20Viewed)
   *
   * Client viewed a specific page
   *
   * Owner: Martha Bawn
   *
   * @param properties The event's properties (e.g. page_location)
   * @param options Amplitude event options.
   */
  pageViewed(
    properties: PageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageViewed(properties), options);
  }

  /**
   * PMI Checked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Checked)
   *
   * For clients with estimated PMI that engage with the PMI quick check: Yes, No, or Unsure
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. pmi_quick_check)
   * @param options Amplitude event options.
   */
  pmiChecked(
    properties: PmiCheckedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PmiChecked(properties), options);
  }

  /**
   * PMI Indicated
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Indicated)
   *
   * Do clients see a red (not yet), orange (soon), or green (maybe now) PMI indication in their Homebot?
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. pmi_status)
   * @param options Amplitude event options.
   */
  pmiIndicated(
    properties: PmiIndicatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PmiIndicated(properties), options);
  }

  /**
   * PMI Info Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Info%20Requested)
   *
   * In our PMI module, trigger is when the Tell me more button is clicked to expand the info panel.
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. inspected_pmi_info)
   * @param options Amplitude event options.
   */
  pmiInfoRequested(
    properties?: PmiInfoRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PmiInfoRequested(properties), options);
  }

  /**
   * PMI Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Removed)
   *
   * In our PMI module, trigger is when the "Ask About PMI Removal" button is clicked to DM the customer providing Homebot to their client.
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  pmiRemoved(
    options?: EventOptions,
  ) {
    return this.track(new PmiRemoved(), options);
  }

  /**
   * Question Asked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Question%20Asked)
   *
   * Client sends a direct message
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. direct_message_topic)
   * @param options Amplitude event options.
   */
  questionAsked(
    properties: QuestionAskedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionAsked(properties), options);
  }

  /**
   * Search Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Completed)
   *
   * Client input a city, county, or zip to search for home listings
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  searchCompleted(
    options?: EventOptions,
  ) {
    return this.track(new SearchCompleted(), options);
  }

  /**
   * Search Modified
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Modified)
   *
   * Client modified home search results using search filters
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. search_filter_added)
   * @param options Amplitude event options.
   */
  searchModified(
    properties: SearchModifiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchModified(properties), options);
  }

  /**
   * Search Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Saved)
   *
   * Client saved their search
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  searchSaved(
    options?: EventOptions,
  ) {
    return this.track(new SearchSaved(), options);
  }

  /**
   * Search Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Sort)
   *
   * Client sorted their listings search results
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. search_sort_updated)
   * @param options Amplitude event options.
   */
  searchSort(
    properties: SearchSortProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchSort(properties), options);
  }

  /**
   * Value Tuned
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Value%20Tuned)
   *
   * Client tuned their value higher or lower
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. tuned_value_direction)
   * @param options Amplitude event options.
   */
  valueTuned(
    properties: ValueTunedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ValueTuned(properties), options);
  }

  /**
   * WIN Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/WIN%20Clicked)
   *
   * Client clicked on one of the WINs
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. win_type)
   * @param options Amplitude event options.
   */
  winClicked(
    properties: WinClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WinClicked(properties), options);
  }

  /**
   * Years In Home Adjusted
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Years%20In%20Home%20Adjusted)
   *
   * Client adjusted the years in home slider above refi options
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  yearsInHomeAdjusted(
    options?: EventOptions,
  ) {
    return this.track(new YearsInHomeAdjusted(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
